import { usePriorityModalMeta } from "@/shared/atoms/usePriorityModal";
import { useState } from "react";
import Confirmation from "../Modal/Confirmation";
import { ModalProps } from "../Modal/Modal";

const ConfirmationModal = ({ onExit, ...props }: ModalProps) => {
  const [meta] = usePriorityModalMeta();
  const { mutation, mutationBody, onSuccess, ...confirmationProps } = meta;
  const [isPending, setIsPending] = useState(false);

  const handleConfirm = () => {
    if (isPending) return;
    setIsPending(true);
    mutation
      .mutateAsync(mutationBody)
      .then((data) => {
        onExit?.();
        onSuccess?.(data);
      })
      .catch((err) => {
        setIsPending(false);
      });
  };

  return (
    <Confirmation
      {...confirmationProps}
      {...props}
      isPending={isPending}
      onSuccess={handleConfirm}
      show={true}
      onExit={onExit}
    />
  );
};

export default ConfirmationModal;
